import { gql } from "@apollo/client";

export const SUBMIT_LOGIN = gql`
  mutation submitLogin($data: LoginReq!) {
    submitLogin(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_LOGOUT = gql`
  mutation submitLogout {
    submitLogout {
      result
      message
    }
  }
`;

export const GET_USER_PROFILE = gql`
  query {
    getUserProfile {
      result
      message
      user {
        email
        firstName
        lastName
        link {
          id
        }
        role {
          name
          superadmin
          permissions {
            privilege
          }
        }
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query {
    getUsers {
      id
      email
      firstName
      lastName
      link {
        id
        fields {
          name
          value
        }
      }
      role {
        id
        name
      }
      linkType
    }
  }
`;

export const GET_ALL_ROLES = gql`
  query {
    getRoles {
      id
      name
      superadmin
      permissions {
        id
        privilege
      }
    }
  }
`;

export const GET_ALL_PRIVILEGES = gql`
  query {
    getPrivileges {
      name
    }
  }
`;

export const SUBMIT_CREATE_ROLE_REQUEST = gql`
  mutation SubmitCreateRole($data: CreateRoleReq!) {
    submitCreateRole(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_DELETE_ROLE_REQUEST = gql`
  mutation SubmitDeleteRole($data: DeleteReq!) {
    submitDeleteRole(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_CREATE_USER_REQUEST = gql`
  mutation SubmitCreateUser($data: CreateUserReq!) {
    submitCreateUser(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_INSPECTION_REQUEST = gql`
  mutation SubmitInspectionReq($data: InspectionReq!) {
    submitInspection(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_INSPECTION_FIXES = gql`
  mutation SubmitInspectionFixes($data: FixesReq!) {
    submitInspectionFixes(data: $data) {
      result
      message
    }
  }
`;

export const GET_CHKLIST_ITEMS = gql`
  query {
    getAllItems {
      id
      name
      description
      type
    }
  }
`;

export const GET_INSPECTIONS = gql`
  query getAllInspections(
    $transporterId: Int
    $vehicleNo: String
    $filter: String
    $page: Int
    $limit: Int
    $status: [String!]
    $month: String
    $defectsView: String
    $trackerCategory: String
  ) {
    getAllInspections(
      transporterId: $transporterId
      vehicleNo: $vehicleNo
      filter: $filter
      page: $page
      limit: $limit
      month: $month
      defectsView: $defectsView
      trackerCategory: $trackerCategory
      status: $status
    ) {
      totalRecords
      records {
        id
        transporter {
          id
          name
          fields {
            name
            value
          }
        }
        customer {
          id
          name
          fields {
            name
            value
          }
        }
        site {
          id
          name
          fields {
            name
            value
          }
        }
        vehicleType
        vehicleReg
        driver {
          id
          name
          fields {
            name
            value
          }
        }
        licenseNo
        remarks
        checklists {
          id
          optionValue
          itemId
          attachments {
            id
            filename
          }
          remarks
          createdAt
          tFixedAt
          fixedAt
        }
        status
        decision
        createdAt
        updatedAt
        hasDefects
        defectsAge
        trails {
          content
        }
      }
    }
  }
`;

export const SUBMIT_SETUP_REQUEST = gql`
  mutation SubmitSetupReq($data: FormReq!) {
    submitSetup(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_INSPECTION_REVIEW_REQ = gql`
  mutation SubmitInspectionReview($data: ReviewReq!) {
    submitInspectionReview(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_SETUP_DELETE_REQ = gql`
  mutation DeleteSetupReq($data: FormDeleteReq!) {
    deleteSetup(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_BULK_SETUP_REQUEST = gql`
  mutation SubmitBulkSetups($data: BulkSetupReq!) {
    submitBulkSetups(data: $data) {
      result
      message
    }
  }
`;

export const GET_SETUPS = gql`
  query getSetups(
    $names: [String!]!
    $filter: String
    $page: Int
    $limit: Int
  ) {
    getSetups(names: $names, filter: $filter, page: $page, limit: $limit) {
      totalRecords
      records {
        id
        name
        status
        fields {
          id
          formId
          name
          type
          value
        }
      }
    }
  }
`;

export const GET_SETUPS_MINIMAL = gql`
  query getSetups($names: [String!]!, $filter: String, $selected: [Int!]) {
    getSetups(names: $names, filter: $filter, selected: $selected) {
      totalRecords
      records {
        id
        name
        status
        fields {
          id
          name
          value
        }
      }
    }
  }
`;

export const GET_SUMMARIZED_REPORT = gql`
  query getSummarizedReport {
    getSummarizedReport {
      name
      vehicleReg
      total
      withoutDefects
      withDefects
    }
  }
`;

export const GET_RANKING_DEFECTS = gql`
  query getRankingDefects {
    getRankingDefects {
      itemName
      transporter
      withDefects
    }
  }
`;

export const GET_INSPECTION_HISTORY_REPORT = gql`
  query getInspectionHistoryReport {
    getInspectionHistory {
      vehicleReg
      transporter
      lastInspection
      agingDays
      countInspections
    }
  }
`;


export const GET_MONTHLY_VEHICLE_DEFECTS_REPORT = gql`
  query getMonthlyVehicleDefects{
    getMonthlyVehicleDefects{
    month
    found
    rectified
    total
    }
  }
`


export const GET_ACCESS_STATUS_SUMMARY_REPORT = gql`
  query getAccessStatusSummary{
    getAccessStatusSummary{
    status
    count
    }
  }
`


export const GET_INSPECTION_STATUS_TRACKER_REPORT = gql`
  query getInspectionStatusTracker{
    getInspectionStatusTracker{
    status
    count
    color
    }
  }
`

export const SUBMIT_RESET_PASSWORD = gql`
  mutation SubmitResetPassword($data: ResetReq!) {
    submitResetPassword(data: $data) {
      result
      message
    }
  }
`;

export const SUBMIT_CHANGE_MY_PASSWORD = gql`
  mutation SubmitChangeMyPassword($data: ChangeMyPasswordReq!) {
    submitChangeMyPassword(data: $data) {
      result
      message
    }
  }
`;